<template>
<div>
 <Toolbar class="contenttopbar">
<template #start>
<h3 class="text-primary mb-2 mt-2 font-medium">{{$store.state.languages.lang_phrases.proje_tedarikcileri}}</h3>
</template>
<template #end>

<span class="text-primary mr-2">{{$store.state.languages.lang_phrases.aktif_donem}}:</span>
<Dropdown v-model="selected_period_id" :options="projectperiods" optionLabel="name" optionValue="id" placeholder="Aktif Dönem" class="mr-2 p-inputtext-sm" @change="activePeriodChanged" />


<span class="p-buttonset hide_on_mobile">
<Button :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" class="p-button-outlined p-button-sm"  @click="createSupplier()"/>
<Button :label="$store.state.languages.lang_phrases.excel_indir" icon="pi pi-cloud-download" class="p-button-outlined p-button-sm" @click="downloadExcel"/>
<Button :label="$store.state.languages.lang_phrases.yukle" icon="pi pi-cloud-upload" class="p-button-outlined p-button-sm" @click="showUploader"/>
</span>

<span class="p-buttonset show_on_mobile">
<Button  icon="pi pi-plus" class="p-button-outlined p-button-sm"  @click="createSupplier()"/>
<Button  icon="pi pi-cloud-download" class="p-button-outlined p-button-sm" @click="downloadExcel"/>
<Button  icon="pi pi-cloud-upload" class="p-button-outlined p-button-sm" @click="showUploader"/>
</span>

</template>
</Toolbar>  

<template v-if="initial_loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!initial_loading">
<div class="mt-4">


<SuppliersTable 
:suppliers="suppliers" 
:customattributes="attributes"
:show_flows="true"  
:show_flow_status="true"
display_page="project"
:loading="loading" 
:totalRecords="totalRecords"
@onPage="onPage"
@onSort="onSort"
@filter="filter"
@renewList="getData"
@customattributeFiltered="customattributeFiltered"
@inclusionChanged="inclusionChanged"
@filterSelected="filterSelected"
:rows="limit"
:page="page"
@searchSupplier="searchSupplier"
:brand_id="brandId"
></SuppliersTable>
</div>
</template>


</div>
</template>
<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {

  name: 'ProjectSuppliers',

  data () {
    return {
      initial_loading:true,
      attributes:[],
      suppliers:[],
      loading:true,      
      page:0,
      limit:10,
      totalRecords:0,
      project_status_filter:null,
      sortField:"created_at",
      sortOrder:1,
      customattribute_query:null,
      projectperiods:[],
      selected_period_id:null,
      downloading_report:false,
      include_deactive:false,
      searchterm:null,
      sort_order:"asc",
      sort_field:"date",
      downloading:false,
    }
  },
  async mounted()
  {
    await this.$store.dispatch('suppliers/setUploadPage',"project") 
    let projectperiods = await this.generalApiGetWithoutLoader("projectperiods/"+this.$route.params.id)
    console.log("projectperiods")
    console.log(projectperiods)
    let active =  await projectperiods.find((item)=>{return item.activeperiod == 1})
    if(active)
    {
      this.selected_period_id = active.id
    }
    this.projectperiods = projectperiods
    await this.getData()
    this.initial_loading = await false
  }, 
  computed:{
    suppliers_renewed()
    {
      return this.$store.state.suppliers.suppliers_renewed
    },
    deletedstate()
    {
        return this.$store.state.ui.deletedstate
    },
    brandId()
    {
      if(this.$store.state.projects.project)
      {
        return this.$store.state.projects.project.brand_id
      }
      return null
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
        if(newVal)
        {
            this.getData()
        }
    },
    suppliers_renewed(newval,oldval)
    {
      if(newval)
      {
        this.getData()
      }
    }
  },
  methods:{
    inclusionChanged(data)
    {
      console.log("inclusionChanged")
      console.log(data)
      this.include_deactive = data
      this.getData()
    },
    async filterSelected(data)
    {
        console.log("filterSelected")
        console.log(data)
        
        let query = data.map((item)=>{
          let obj = {
            id:item.id,
            min:item.min,
            max:item.max,
            options:item.options,
            type:item.type
          }
          return obj
        })
        this.customattribute_query = query
        console.log(query)
        this.page = 0
        this.getData()
    },
    async customattributeFiltered(customattribute_query)
    {
      if(customattribute_query.customattribute_id)
      {
        this.customattribute_query = customattribute_query
        
      }
      this.getData()
      
    },
     async onPage(event)
    {
        console.log("onPage")
        console.log(event)
        this.page = await event.event.page
        this.limit = await event.event.rows
        await this.getData()
    },
    onSort(event)
    {
        console.log("onSort")
        console.log(event)
        if(event.sortOrder===1)
        {
          this.sort_order = "asc"
        }
        else
        {
          this.sort_order = "desc"
        }
        this.sort_field = event.sortField
        this.page = 0
        this.getData()
    },
    async filter(event)
    {
      console.log("ps filter")
      console.log(event)
      this.page = 0
      if(event.filters.flow_status.value)
      {
        this.project_status_filter = await  event.filters.flow_status.value
      }
      else
      {
        this.project_status_filter = await null
      }
      console.log("filter")
      console.log(this.project_status_filter)
      await this.getData()
    },
    activePeriodChanged()
    {
      this.getData()
    },
    async getData()
    {
      console.log("getData")
      this.loading = await true
      this.attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.projects.project.brand.id)
      console.log(this.attributes)
      let data = await this.generalApiGetWithoutLoader("project/suppliers/"+this.$route.params.id+"/"+this.page+"/"+this.limit+"/"+this.selected_period_id+"?project_status_filter="+JSON.stringify(this.project_status_filter)+"&customattribute_query="+JSON.stringify(this.customattribute_query)+"&search="+this.searchterm+"&sort_order="+this.sort_order+"&sort_field="+this.sort_field+"&include_deactive="+this.include_deactive)

      /*
      if(this.customattribute_query)
      {
        
        data = await this.generalApiGetWithoutLoader("project/suppliers/"+this.$route.params.id+"/"+this.page+"/"+this.limit+"/"+this.selected_period_id+"?flow_status="+this.project_status_filter+"&customattribute_query="+JSON.stringify(this.customattribute_query)+"&sort_order="+this.sortOrder+"&sort_field="+this.sortField)
      }
      else
      {
        
        data = await this.generalApiGetWithoutLoader("project/suppliers/"+this.$route.params.id+"/"+this.page+"/"+this.limit+"/"+this.selected_period_id+"?flow_status="+this.project_status_filter+"&sort_order="+this.sortOrder+"&sort_field="+this.sortField)
      }
      */




      console.log("data")
      console.log(data)
      this.totalRecords = await data.meta.total

      
      for(let projectsupplier of data.data)
      {
        /*
        projectsupplier.name = projectsupplier.supplier.name
        projectsupplier.suppliercode = await projectsupplier.supplier.suppliercode
        projectsupplier.flows = projectsupplier.supplier.flows
        projectsupplier.projectsupplier_id = await projectsupplier.id
        projectsupplier.id = await projectsupplier.supplier.id
        */

        /*
        projectsupplier.name = await projectsupplier.supplier_name
        projectsupplier.id = await projectsupplier.supplier_id
        projectsupplier.flow_status = await projectsupplier.status
        projectsupplier.activeflow = await {
          type:projectsupplier.activeflow_type,
          name:projectsupplier.activeflow_name
        }
         */
        
      }

     


      this.suppliers = await data.data
      console.log("suppliers")
      console.log(this.suppliers)
      this.$store.dispatch('suppliers/setAttributes',this.attributes) 
      await this.$store.dispatch('suppliers/setSuppliersRenewed',false) 
      this.loading = await false
    },

     async searchSupplier(searchterm)
    {
      console.log("searchSupplier")
      console.log(searchterm)
      if(searchterm || searchterm!=="")
      {  
        this.searchterm = await searchterm.toUpperCase();
        this.getData()               
      }
      else
      {
        this.searchterm = null
        this.getData()
      }
    },
    async createSupplier()
    {
      let obj = await {item:"project",id:this.$route.params.id}     
      await console.log(obj) 
      await this.$store.dispatch('suppliers/setSupplierHistoryObj',obj) 
      await this.$router.push({name:"CreateSupplier"})      
    },
    showUploader()
    {
      console.log("show uploader")
      this.$store.dispatch('suppliers/setUploadDialog',true) 
    },
    async downloadExcel()
    {
      
      
      //return false
      let sheet = []
      let row = await [
      "Tedarikçi İsmi",
      "Tedarikçi Kodu(Markaya Özel)",
      "Yetkili İsmi",
      "Yetkili Email",
      "Yetkili Tel No(Tercihe Bağlı)",
      "Yetkili Görevi (Tercihe Bağlı)"
      ]
      for(let item of this.attributes)
      {
        await row.push(item.name)
      }
      await sheet.push(row)
      let row2 = await [
      "",
      "",
      "",
      "",
      "",
      "",
      ]
      for(let item of this.attributes)
      {
        if(item.type=="string")
        {
          await row2.push("Yazı İle")
        }
        if(item.type=="number")
        {
          await row2.push("Sayı İle")
        }
        if(item.type=="switch")
        {
          await row2.push("'Evet'/'Hayır'")
        }
        if(item.type=="select")
        {
          let text = ""
          for(let element of item.options)
          {
            text = await text+element.name+","
          }
          await row2.push(text)
        }
        
      }
      await sheet.push(row2)


      let ws = await XLSX.utils.json_to_sheet(sheet)
      let wb = await XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(wb,ws,"Tedarikçiler")
      await XLSX.writeFile(wb,this.$store.state.projects.project.brand.name+" tedarikçileri.xls")
    }
  }
}
</script>

<style lang="css" scoped>
</style>